export default __webpack_public_path__ + "static/media/refer-and-earn.e6183fd9.jpg";